module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-Italic-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-Italic-webfont.woff
// module id = 358
// module chunks = 0